import upsertStudyDoc from '../../api/study/upsertStudyDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useUpsertStudy() {
  const {fn, loading, error} = useFunctionWrap(upsertStudyDoc);

  return {
    upsertStudy: fn,
    loading,
    error,
  };
}
